import { useEffect, useState } from 'react'
import { initializeTelegram } from './utils/telegram'
import { getLastProfile, StoredProfile, saveProfile } from './utils/storage'
import {
  calculateLifePathNumber,
  calculateDestinyNumber,
  calculateSoulUrgeNumber,
  calculateExpressionNumber,
  calculateBirthdayNumber,
} from './utils/numerology'
import { MainView } from './components/MainView'
import { ProfileSetup } from './components/ProfileSetup'
import { MagicBackground } from './components/MagicBackground'
import { texts } from './texts'
import './index.css'

export default function App() {
  const [initialized, setInitialized] = useState(false)
  const [profile, setProfile] = useState<StoredProfile | null>(null)
  const [profileLoaded, setProfileLoaded] = useState(false)

  useEffect(() => {
    const initialize = async () => {
      try {
        initializeTelegram()

        // Load profile from LocalStorage
        const savedProfile = getLastProfile()
        setProfile(savedProfile)
        setProfileLoaded(true)
        setInitialized(true)
      } catch (error) {
        console.error('Failed to initialize Telegram:', error)
        setProfileLoaded(true)
        setInitialized(true)
      }
    }

    initialize()
  }, [])

  const handleProfileSetup = (name: string, dateOfBirth: string) => {
    // Calculate all numbers
    const lifePathNumber = calculateLifePathNumber(dateOfBirth)
    const destinyNumber = calculateDestinyNumber(name)
    const soulUrgeNumber = calculateSoulUrgeNumber(name)
    const expressionNumber = calculateExpressionNumber(name)
    const birthdayNumber = calculateBirthdayNumber(dateOfBirth)

    // Save profile
    const newProfile = saveProfile(name, dateOfBirth, {
      lifePathNumber,
      destinyNumber,
      soulUrgeNumber,
      expressionNumber,
      birthdayNumber,
    })

    setProfile(newProfile)
  }

  if (!initialized || !profileLoaded) {
    return (
      <>
        <MagicBackground />
        <div className="mg-layer" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: 'var(--font-serif)',
          fontSize: '1.5rem',
          color: 'var(--mg-gold-soft)',
          textShadow: '0 0 16px rgba(232, 200, 122, 0.4)',
        }}>
          {texts.app.loading}
        </div>
      </>
    )
  }

  return (
    <>
      <MagicBackground />
      <div className="mg-layer">
        {!profile ? (
          <ProfileSetup onProfileCreated={handleProfileSetup} />
        ) : (
          <MainView profile={profile} onProfileUpdate={setProfile} />
        )}
      </div>
    </>
  )
}
